module.exports = __webpack_public_path__ + "img/bezos.eab04ca6.jpeg";